import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DFechaInscripcionRUT, DRenta210IngresoServicios } from '@dian-api/renta210-ingreso';
import { DItemConfiguracion, DMensajes, DOperacionesGeneralesIngresoServicio, DOperacionesMatematicasServicio, DUtilidadesFormularioServicio } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DReciboPagoDialogoServicio } from '@dian-cmp/recibo-pago';
import { DReciboPagoExteriorDialogoServicio } from '@dian-cmp/recibo-pago490-exterior';
import { DAccesoFormato, DDiligenciamientoServicios } from '@dian/api-diligenciamiento';
import { DVersionRutaFormato, DListaDocumentos, DFirmaElectronica, DAniosFormato, DPeriodicidadFormato, DPeriodoFormato, DFormularioServicio, DInfoResumenFormulario, DDocumento,DMarcasDocumento } from '@dian/api-formulario';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DRutServicios, DTipoContribuyente } from '@dian/api-rut';
import { DContextoMuisca, DContextoMuiscaServicio, DLogger, DRespuestaSimple } from '@dian/core';
import { DFormularioConfiguracion } from '../../configuracion/dformulario-configuracion';
import { DIdentificadorDocumento } from '../identificadorDocumento/didentificador-documento';
import { MatDialog } from '@angular/material';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { DConceptoLiquidacionRecibo, DLiquidacionRecibo } from '@dian-api/recibo-pago490';
import { DLiquidacionReciboExterior } from '@dian-api/recibo-pago490-exterior';
import { GeneralService } from '../../services/general.service';
import { ModalService, ModalType } from '../../modal/services/modal.service';
import { Buffer } from 'buffer';
import { DCodBorradorSugerida, DRenta210v17Servicios} from '@dian-api/renta210v17';
import { DRenta210v18Servicios, DDeclaracionSugerida } from '@dian-api/renta210v18';
import { DBasicosParametricasServicios, DValorPeriodico } from '@dian/api-basicos-parametricas';
import { Formulario210Servicio } from '../../services/formulario.servicio';
import { CalculoExtemporaneidadComponent } from '../shared/modals/calculo-extemporaneidad/calculo-extemporaneidad.component';
import { ExtemporaneidadComponent } from '../../modal/extemporaneidad/extemporaneidad.component';
import { stringify } from 'querystring';
import { DDevolucionesServicios, DDilPersonaRutJSON } from '@dian-api/devoluciones';
import { DSugeridaNubeServicios } from '@dian-api/sugerida-nube';


const CARACTERSUGERIDA ='c';
const FORMATO=210;

@Component({
  selector: 'app-contenedor',
  templateUrl: './contenedor.component.html',
  styleUrls: ['./contenedor.component.css'],
  providers: [
    DNotificacionServicio,
    DRenta210IngresoServicios,
    DRutServicios,
    DUtilidadesFormularioServicio,
    DReciboPagoDialogoServicio,
    DContextoUsuarioServicio,
    DDiligenciamientoServicios,
    DReciboPagoExteriorDialogoServicio,
    
  ]
})
export class ContenedorComponent implements OnInit {
  cards: {titulo: string; active: boolean; icono: string; link: string; iconowhite: string; visible: boolean}[] = [];
  show_item_description = false;
  routerLinkActive = '';



  // ------------------------------------------------------------------------
  private versionesRuta: Array<DVersionRutaFormato>;
    public mostrarOtros: boolean = false;
    private xtieneFirma = false;    
    private aniosFraccion = [];
    private anioSeleccionadoPresentados:number;
    private arrDocumentosDiligenciamiento:DListaDocumentos;
    private arrDocumentosPresentados:DListaDocumentos;
    private arrDocumentosDefinitivos:DListaDocumentos;
    private arrencabezadoPieForm:Array<DIdentificadorDocumento>;
    private arrDocumentosFactura:DListaDocumentos;
    private constribuyenteId:string;
    private configuracionFormulario:DFormularioConfiguracion;
    private esFirmanteElectronico: DFirmaElectronica;
    private enProceso:boolean = true;
    private estadosCarga = {
        pendientes: false,
        presentados: false,
        definitivos: false,
        anios: false
    };
    private habilitarFraccionAnio:boolean = false;
    private hayFraccion:boolean = false;
    private hayInicial:boolean = false;
    private fraccionAnio:boolean = true;
    private primerPago:boolean = false;
    private firmaRequerida:boolean = false;
    private operacionesGenerales:DOperacionesGeneralesIngresoServicio; 
    private mostrarNuevoBorrador:boolean = true;
    private mostrarNuevoBorradorFraccion:boolean = false;   
    private mostrarDocumentosEnProceso:boolean = true;
    private mostrarDocumentosEnBorrador:boolean = true;
    private mostrarFacturaRenta:boolean = true;
    private mostrarDocumentosEnDefinitivo:boolean = true;
    private periodicidadDeshabilitada:boolean = true;    
    private aniosFormato:DAniosFormato;
    public modoUsoFraccion210v16:number = 15080007;
    public permiteFraccion:boolean = false;
    private anioSeleccionado:number;
    private anioSeleccionadoFraccion:number;
    private periodicidadFormato:DPeriodicidadFormato;
    private periodicidadSelecionada:string ='anual';   
    private periodosFormato:DPeriodoFormato;
    private periodoSeleccionado = null;  
    private tipoContribuyente: DTipoContribuyente;
    private existenBorradoresDefinitivosInicial: boolean = false;
    private existenBorradoresDefinitivosFraccion: boolean = false;
    public enProcesoPago: boolean = false;
    private datosContexto = new DContextoMuisca();
    private dcontextoMuiscaServicio : DContextoMuiscaServicio;
    public existenDocsPresentadosAnio:boolean = false;
    public disableBtnPagoCuotas:boolean = true;
    private fechaInscripcionRUT : number;
    public dformulario : DFormularioServicio;
    tipoContribuyenteConsultado = false;
    firmaElectronicaConsultada = false;
    domain = '';
    sugerida : number;
    paramValue: string;
    private actividadEconomica: any;
    private codBorradorSugerida: DCodBorradorSugerida = new DCodBorradorSugerida();
    public listaDeclaracionSugerida: any;
    public declaracionSugerida: any;
    public aporteVoluntario:number;
    extemporaneidad : any;
    private personaRUTJSON: DDilPersonaRutJSON;
    boolcandidato: boolean;
    

  constructor(private router : Router,
        private dialog: MatDialog,
        private dNotificacionServicio: DNotificacionServicio,
        private dServicioRESTAPI: DRenta210IngresoServicios,
        private dRutServicios: DRutServicios,
        private datosDevoluciones: DDevolucionesServicios,
        private dContextoUsuarioServicio: DContextoUsuarioServicio,
        private logger: DLogger,
        private dutilidades: DUtilidadesFormularioServicio,
        private dReciboPagoServicio: DReciboPagoDialogoServicio,
        private dDiligenciamientoServicios:DDiligenciamientoServicios,
        private dReciboPagoExteriorDialogoServicio:DReciboPagoExteriorDialogoServicio,
        private generalServcice: GeneralService,
        private modalService: ModalService,
        private route: ActivatedRoute,
        private dRenta210v18Servicios: DRenta210v18Servicios,
        protected dutilidadesMat: DOperacionesMatematicasServicio,
        private dBasicosParametricasServicios:DBasicosParametricasServicios,
        private dSerivicoFormulario210: Formulario210Servicio,
        private _restSugeridaNube:DSugeridaNubeServicios,) { 

    this.construirMenu();
    router.events.subscribe((route) => {
      if (route instanceof NavigationEnd) {       
        this.routerLinkActive = route.url === '/' ? route.urlAfterRedirects : route.url;
        this.cards.forEach(card =>{
          card.active = card.link === this.routerLinkActive ? true : false;
        }) 
      }
    });
    this.operacionesGenerales = new DOperacionesGeneralesIngresoServicio(this.dNotificacionServicio, this.dServicioRESTAPI, this.dialog); 
    this.configuracionFormulario = new DFormularioConfiguracion();
    this.arrDocumentosDiligenciamiento = new DListaDocumentos();  
    this.arrDocumentosPresentados = new DListaDocumentos();
    this.arrDocumentosDefinitivos = new DListaDocumentos();
    this.arrDocumentosFactura = new DListaDocumentos();
    this.aniosFormato = new DAniosFormato();
    //this.aniosFraccion = new Array<number>();
    this.periodicidadFormato = new DPeriodicidadFormato();
    this.periodosFormato = new DPeriodoFormato();
    this.tipoContribuyente = new DTipoContribuyente();
    this.esFirmanteElectronico = new DFirmaElectronica();
    this.datosContexto = new DContextoMuisca();
    this.versionesRuta = new Array<DVersionRutaFormato>();
    
  }

  ngOnInit() {
    this.domain = window.location.origin;
    setTimeout(() => {  
      this.consultarFirmanteElectronico('desconocido');      //Esta linea inicia todo el proceso de la clase abstracta                     
    }, 50);        
    this.mostrarNuevoBorrador=true;
    this.route.queryParams.subscribe(params => {
        this.paramValue = params['idRequest'];
        if(this.paramValue) {
            console.log("parram: -------------------------------->", this.paramValue);
            const decodedBuffer = Buffer.from(this.paramValue, 'base64');
            const decodedString = decodedBuffer.toString('utf-8');
            this.sugerida = parseInt(decodedString.split('=')[1]);
           
        }
    });

    this.generalServcice.crearBorrador$.subscribe(data => {
        this.anioSeleccionado = data.anioSeleccionado;
        this.periodicidadSelecionada = data.periodicidadSelecionada;
        this.periodoSeleccionado = data.periodoSeleccionado;
        data.modoNoExperto ? this.validarAnularDefinitivos(data.anioSeleccionado, data.dataAdicional, true) : this.validarAnularDefinitivos(data.anioSeleccionado, data.dataAdicional)
      });

      this.generalServcice.editarFormulario$.subscribe(data=>{
        data.modoNoExperto ? this.editarFormulario(data, true) : this.editarFormulario(data);
      });

      this.generalServcice.corregirFormulario$.subscribe((data)=>{
        data.modoNoExperto ? this.corregirFormulario(data, true) : this.corregirFormulario(data);
      });

      this.generalServcice.pagarFormulario$.subscribe(data=>{
        this.fraccionAnio = data.fraccionAnio;
        this.pagarFormularioINIT(data.id, data.anio, data.periodo, data.modo, data.item);
      });
    this.generalServcice.fraccionAnio$.subscribe(data =>{
     /*    console.log("data Fraccion: ", data); */
        this.anioSeleccionadoFraccion = data.anio;
        this.enProceso = data.enProceso;
        this.fraccionAnio = data.fraccionAnio;
        this.validarPuedePresentarFraccion();
    })

    this.generalServcice.pagoCuotas$.subscribe(data =>{
/*         console.log("data cutas: ", data); */
        this.anioSeleccionado = data.anioSeleccionado;
        this.dirigirPagoPrimeraCuota();
    })

    this.generalServcice.copiarFormulario$.subscribe(data=>{
   /*      console.log("data copiar form ",data) */
        this.copiarFormulario(data);
    })
 /*   this.generalServcice.devoluciones$.subscribe(
        data=>{
                  console.log("data devoluciones ",data);
                 this.consultarSaldoDevoluciones();
        })*/
        
  }

  /**
    * @desc Funcion para obtener si es o no extemporáneo
    */

  consultarExtemporaneidad() {
        let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
        /////////////////eliminar /////////////////////
       // let documentoInicial = new DDocumento();
       // this.obtenerDeclaracionSugerida(documentoInicial,2023);
        //////////////////////////////////////////////////
        this.dRenta210v18Servicios.consultarExtemporaneidad(this.datosContexto.NitUsuario, ''+this.sugerida, 'inicial').subscribe(res=> {
            precarga.close();
            console.log("resultado extemporaneidad: --------------------------------->", res)
            this.extemporaneidad = res;
            this.obtenerSugerida(this.sugerida)
        }, error =>{
            precarga.close();
            this.dNotificacionServicio.mostrarDialogoError('Error obteniendo extemporaneidad');
        })
  }

  mostrarDialogoExtemporaneidad(modelo: DDocumento, metodo: string = 'crear') {
    const datosModal = modelo.doc.cuerpo.cs_id_340 ? 
         {patrimonioLiquido: modelo.doc.cuerpo.cs_id_339, gradualidad: modelo.doc.cuerpo.cs_id_340} : {};
    
    let config = {
        disableClose: true,
        maxWidth: '400px',
        data: datosModal
      };
      let dialogRef = this.dialog.open(ExtemporaneidadComponent, {disableClose: false, data: datosModal});
      //this.dialog.open(CalculoExtemporaneidadComponent, config);
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.gradualidad && result.patrimonioLiquido) {
          console.log('resulta: ', result)
          //this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla29, true);
          let patrimonioLiquido:string=`${result.patrimonioLiquido}`;
          modelo.doc.cuerpo.cs_id_339 =this.dutilidadesMat.deshacerFormatoMoneda( patrimonioLiquido);
          modelo.doc.cuerpo.cs_id_340 = result.gradualidad
          this.recalcularCasillas(modelo, metodo);
        }
      }); 
  }



    recalcularCasillas(modelo: DDocumento, metodo: string = 'crear') {
        this.dSerivicoFormulario210.setModelo(modelo);
        this.dSerivicoFormulario210.calcularTotalIngresos();
        this.dSerivicoFormulario210.sancionExtemporaneidad();
        let modeloTmp = this.dSerivicoFormulario210.getModelo();
        console.log("***********************************", modeloTmp);
        metodo === 'crear' ? this.guardarActualizarBorrador(modeloTmp) : this.actualizarBorrador(modeloTmp);
    }

//___________________________________________________________________________
    //   protected actualizarBorrador(modelo:DDocumento) {
    //     let modeloBorrador: DDocumento = modelo;
    //     let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    //     let observableServicio = this.DRenta210v18Servicios.actualizarFormulario(`${modeloBorrador.doc.cab.id}`, modeloBorrador, 'inicial');
    //     let modeloGuardado=new DDocumento();
    //     observableServicio.subscribe(
    //         res => {
               
    //             let transporte=(<any>res).respuesta.listaResultados.resultado.textoResultado.doc;
    //             modeloGuardado = <DDocumento>transporte;
    //             this.imprimirFormularioBLOB(modeloGuardado)
    //             this.logger.info(DMensajes.BORRADOR_GUARDADO);
    //             precargaProceso.close();
    //         },
    //         error => {
    //             precargaProceso.close();
    //             this.codBorradorSugerida.estadoUX='error';
    //         }
    //     );
    // }

    protected actualizarBorrador(modelo:DDocumento) {
        let modeloBorrador: DDocumento = modelo;
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
        let observableServicio = this.dRenta210v18Servicios.actualizarFormulario(`${modeloBorrador.doc.cab.id}`, modeloBorrador, 'inicial');
        let modeloGuardado=new DDocumento();
        observableServicio.subscribe(
            res => {
               
                let transporte=(<any>res).respuesta.listaResultados.resultado.textoResultado;
                modeloGuardado = <DDocumento>transporte;
                this.imprimirFormularioBLOB(modeloGuardado)
                this.logger.info(DMensajes.BORRADOR_GUARDADO);
                precargaProceso.close();
            },
            error => {
                precargaProceso.close();
                this.codBorradorSugerida.estadoUX='error';
            }
        );
    }

    



    /**
    * @desc Funcion para obtener la borrador con la declaración sugerida
    */

    private obtenerSugerida(anio:number) {
        
        const precarga = this.dNotificacionServicio.mostrarDialogoCarga();
        let observableServicio = this.dRenta210v18Servicios.obtenerBorradorInicial(anio,'anual',1,'inicial');
        let documentoInicial = new DDocumento();
        observableServicio.subscribe(
             res => {

               this.logger.info("Obtener documento inicial ", res);
               
               documentoInicial = <DDocumento>res;
               
               if(documentoInicial.doc.cab.id === -1) 
                {
                    this.logger.info("Borrador inicial vacio");
                    documentoInicial=this.respuestaExitosa(documentoInicial);
                    documentoInicial.doc.cuerpo.cs_id_337='1';
                    documentoInicial.doc.cuerpo.cs_id_341= `${this.extemporaneidad.fechaLimite}`;
                    this.obtenerDeclaracionSugerida(documentoInicial,documentoInicial.doc.cab.cs_id_1);
                }
                else
                {
                    documentoInicial.doc.cuerpo.cs_id_343 = this.extemporaneidad.impuestoNetoAnterior ?  `${this.extemporaneidad.impuestoNetoAnterior}` : '0';
                    documentoInicial.doc.cuerpo.cs_id_342 = this.extemporaneidad.numeroAnnios ? `${this.extemporaneidad.numeroAnnios}`: '0';
                    this.dSerivicoFormulario210.setModelo(documentoInicial);
                    this.dSerivicoFormulario210.operacionCs133();
                    documentoInicial = this.dSerivicoFormulario210.getModelo();
                    documentoInicial.doc.cuerpo.cs_id_134 = this.dutilidadesMat.deshacerFormatoMoneda( documentoInicial.doc.cuerpo.cs_id_134);
                    documentoInicial.doc.cuerpo.cs_id_136 = this.dutilidadesMat.deshacerFormatoMoneda( documentoInicial.doc.cuerpo.cs_id_136);
                    documentoInicial.doc.cuerpo.cs_id_137 = this.dutilidadesMat.deshacerFormatoMoneda( documentoInicial.doc.cuerpo.cs_id_137);
                    if(documentoInicial.doc.cuerpo.cs_id_337=='1')
                    {
                        if (this.extemporaneidad.esExtemporaneo && !documentoInicial.doc.cuerpo.cs_id_26) {
                            this.obtenerDeclaracionSugerida(documentoInicial,documentoInicial.doc.cab.cs_id_1, false);
                          //  this.mostrarDialogoExtemporaneidad(this.documentoInicial, 'actualizar');
                        } else {
                            this.obtenerDeclaracionSugerida(documentoInicial,documentoInicial.doc.cab.cs_id_1, false);
                            this.actualizarBorrador(documentoInicial);
                            //this.imprimirFormularioBLOB(this.documentoInicial);
                        }
                    }
                    else
                    {
                        this.codBorradorSugerida.estadoUX='borrador';
                        this.codBorradorSugerida.ideDocumento = documentoInicial.doc.cab.id;
                        this.codBorradorSugerida.saldoaPagar =  <string>documentoInicial.doc.cuerpo.cs_id_136;
                        this.codBorradorSugerida.saldoaFavor =  <string>documentoInicial.doc.cuerpo.cs_id_137;
                        this.codBorradorSugerida.pdfDocumento = null;
                        this.redireccionarSugerida(this.codBorradorSugerida.estadoUX);
                    }

                }    
            precarga.close();
            },
            error => {
                if (error) {
                    precarga.close();
                    if(error.codigo === 500) 
                    {
                        let detatallado:string=error.mensaje;
                        let presentado:string='Error Diligenciamiento Inicial';
                        if(detatallado.indexOf(presentado) !== -1)
                        {
                            this.codBorradorSugerida.estadoUX='presentada';
                            this.codBorradorSugerida.ideDocumento = null;
                            this.codBorradorSugerida.saldoaPagar =  null;
                            this.codBorradorSugerida.saldoaFavor =  null;
                            this.codBorradorSugerida.pdfDocumento = null;
                            this.redireccionarSugerida(this.codBorradorSugerida.estadoUX);
                        }
                        else{
                            this.codBorradorSugerida.estadoUX='error';
                            this.codBorradorSugerida.ideDocumento = null;
                            this.codBorradorSugerida.saldoaPagar =  null;
                            this.codBorradorSugerida.saldoaFavor =  null;
                            this.codBorradorSugerida.pdfDocumento = null;
                        }
                    }   
                    else
                    {
                        this.codBorradorSugerida.estadoUX='error';
                        this.codBorradorSugerida.ideDocumento = null;
                        this.codBorradorSugerida.saldoaPagar =  null;
                        this.codBorradorSugerida.saldoaFavor =  null;
                        this.codBorradorSugerida.pdfDocumento = null;

                    }           
                    
                }
               
            }
        );
    }

    public imprimirFormularioBLOB(documentoInicial:DDocumento) {
        let observableServicio =this.operacionesGenerales.imprimirFormularioBLOB(''+documentoInicial.doc.cab.id); 
        observableServicio.subscribe(
            res => {
                this.codBorradorSugerida.estadoUX='sugerida';
                this.codBorradorSugerida.ideDocumento = documentoInicial.doc.cab.id;
                this.codBorradorSugerida.saldoaPagar =  <string>documentoInicial.doc.cuerpo.cs_id_136;
                this.codBorradorSugerida.saldoaFavor =  <string>documentoInicial.doc.cuerpo.cs_id_137;
                this.codBorradorSugerida['modelo'] = documentoInicial;
                this.codBorradorSugerida['declaracionSugerida'] = this.declaracionSugerida;
                if(res.blob) {
                    this.codBorradorSugerida.pdfDocumento = res.blob;
                    this.generalServcice.enviarSugerida(this.codBorradorSugerida);
                    this.redireccionarSugerida(this.codBorradorSugerida.estadoUX);
                }
                else {
                    this.codBorradorSugerida.pdfDocumento = null;        
                }    
            },
            error => {
                this.codBorradorSugerida.estadoUX='sinSugerida';
                this.codBorradorSugerida.ideDocumento = null;
                this.codBorradorSugerida.saldoaPagar =  null;
                this.codBorradorSugerida.saldoaFavor =  null;
                this.codBorradorSugerida.pdfDocumento = null;
                this.redireccionarSugerida(this.codBorradorSugerida.estadoUX);                
            }
        );
           
    }


    public respuestaExitosa(modelo:DDocumento) {
        //Se inicializan casillas numericas de cuerpo que estan nulas o en ceros, en caso de tener valor se formatea
        let keys = Object.keys(modelo.doc.cuerpo);
        for (let i in keys) {
            let casilla = Number(keys[i].substring(6));           
            if (casilla >= 27 && casilla <= 340) {
                if (!modelo.doc.cuerpo[keys[i]]) {
                    modelo.doc.cuerpo[keys[i]] = "0";
                } else {
                    let valor =modelo.doc.cuerpo[keys[i]];
                    modelo.doc.cuerpo[keys[i]] = this.dutilidadesMat.obtenerFormatoMoneda(valor ? valor : "0");                                
                }   
            }
        }
        return modelo;
    }

    /////////////////servicio 210 v18
    //cargar sugerida Nube
private obtenerDeclaracionSugerida(modelo:DDocumento,anioDeclaracion:number, calculos =  true)
  {
    
    this.dContextoUsuarioServicio.consultarContextoUsuarioMuisca().subscribe(
        (res: DContextoMuisca) => {
          const contexto = <DContextoMuisca>JSON.parse(sessionStorage.getItem('DIAN-MUISCATK'));
          if (!contexto) {
            this.dNotificacionServicio.mostrarDialogoError("Error obteniendo el contexto para la declaraciÃ³n sugerida desde nube");
            return;
          }
          this._restSugeridaNube.initialize(contexto.token.idToken, contexto.token.clientId);
          const nitenviado=this.datosContexto.ANombrePropio ? ""+this.datosContexto.NitUsuario : ""+this.datosContexto.NitOrganizacion;
          this.dRenta210v18Servicios.consultarNitFor(nitenviado).subscribe(
            (data: DDilPersonaRutJSON) => 
            this.getSugerida(modelo,anioDeclaracion, calculos,Number(data.codigoPersonaMas)),//res.tipoDocumento, res.NitUsuario
            error => console.log(error)
          );  
          
            }
        );  
    
  }
  getSugerida(modelo:DDocumento,anioDeclaracion:number, calculos =  true, codigoPersona:number)
  {
    const preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    //idePersonaRut: number, anioDeclaracion: number, periodo:number,periodicidad:string)
    this._restSugeridaNube.obtenerSugeridaNube(codigoPersona,anioDeclaracion,1,'anual').subscribe(
        res => {
            if (!res) return;
            this.asignaCasillaSugerida(res);
            if(this.declaracionSugerida)
            { 
            if (calculos) {
                // modelo.doc.cuerpo.cs_id_112='0';
                // modelo.doc.cuerpo.cs_id_113='0';
                modelo= this.calcularFormularioSugerida(modelo);  
                this.obtenerValorUVTIngreso(""+this.sugerida,modelo);
            }
            }
            else
            {
            this.codBorradorSugerida.estadoUX='sinSugerida';
            this.codBorradorSugerida.ideDocumento = null;
            this.codBorradorSugerida.saldoaPagar =  null;
            this.codBorradorSugerida.saldoaFavor =  null;
            this.codBorradorSugerida.pdfDocumento = null;
            this.redireccionarSugerida(this.codBorradorSugerida.estadoUX);
            }
            preloader.close();
        }, 
        error=>{    
            
            preloader.close();
            this.codBorradorSugerida.estadoUX='sinSugerida';
            this.codBorradorSugerida.ideDocumento = null;
            this.codBorradorSugerida.saldoaPagar =  null;
            this.codBorradorSugerida.saldoaFavor =  null;
            this.codBorradorSugerida.pdfDocumento = null;
            this.redireccionarSugerida(this.codBorradorSugerida.estadoUX);
            
        }
    );
  }

   /* private obtenerDeclaracionSugerida(modelo:DDocumento,anioDeclaracion:number, calculos =  true){
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
        this.dRenta210v18Servicios.obtenerDeclaracionSugerida(modelo.doc.cab.cs_id_5,anioDeclaracion).subscribe(
          res=>{
                this.listaDeclaracionSugerida = <any>res;
                let validaFactura=false;
                for (var i = 0; i < this.listaDeclaracionSugerida.length; i++) {
                  if(this.listaDeclaracionSugerida[i].ideTipoRegistro =='60600003')  ////////////Factura Renta
                    {
                      this.declaracionSugerida=this.listaDeclaracionSugerida[i];  
                      validaFactura=true;
                      break;
                    }
                }
                if(!validaFactura)
                {
                  for (var i = 0; i < this.listaDeclaracionSugerida.length; i++) {
                  if(this.listaDeclaracionSugerida[i].ideTipoRegistro =='60600002') /////Alerta Omiso
                    {
                      this.declaracionSugerida=this.listaDeclaracionSugerida[i];  
                      validaFactura=true;
                      break;
                    }
                }
               }
               if(!validaFactura)
               {
                 for (var i = 0; i < this.listaDeclaracionSugerida.length; i++) {
                  if(this.listaDeclaracionSugerida[i].ideTipoRegistro =='60600001') /////Declaración Sugerida
                   {
                     this.declaracionSugerida=this.listaDeclaracionSugerida[i];  
                     validaFactura=true;
                     break;
                   }
               }
              }
              if(this.declaracionSugerida)
              { 
                if (calculos) {
                    // modelo.doc.cuerpo.cs_id_112='0';
                    // modelo.doc.cuerpo.cs_id_113='0';
                    modelo= this.calcularFormularioSugerida(modelo);  
                    this.obtenerValorUVTIngreso('2023',modelo);
                }
              }
              else
              {
                this.codBorradorSugerida.estadoUX='sinSugerida';
                this.codBorradorSugerida.ideDocumento = null;
                this.codBorradorSugerida.saldoaPagar =  null;
                this.codBorradorSugerida.saldoaFavor =  null;
                this.codBorradorSugerida.pdfDocumento = null;
                this.redireccionarSugerida(this.codBorradorSugerida.estadoUX);
              }
              precargaProceso.close();
            }, error=>{    
                precargaProceso.close();
                this.codBorradorSugerida.estadoUX='sinSugerida';
                this.codBorradorSugerida.ideDocumento = null;
                this.codBorradorSugerida.saldoaPagar =  null;
                this.codBorradorSugerida.saldoaFavor =  null;
                this.codBorradorSugerida.pdfDocumento = null;
                this.redireccionarSugerida(this.codBorradorSugerida.estadoUX);
          }
        );
          
      }
      */

      private calcularFormularioSugerida(modelo:DDocumento)
      {
          //Cargar variable de aceptación
          this.declaracionSugerida.ideAceptacion = 'S'; 
          //Cargar valores en el borrador        
            modelo.doc.cuerpo.cs_id_29 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla29, true);
            modelo.doc.cuerpo.cs_id_30 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla30, true);
            modelo.doc.cuerpo.cs_id_32 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla32, true);
            modelo.doc.cuerpo.cs_id_33 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla33, true);
            modelo.doc.cuerpo.cs_id_35 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla35, true);
            modelo.doc.cuerpo.cs_id_36 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla36, true);
            modelo.doc.cuerpo.cs_id_39 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla39, true);
            //  modelo.doc.cuerpo.cs_id_41 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla41, true);
            modelo.doc.cuerpo.cs_id_43 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla43, true);
            modelo.doc.cuerpo.cs_id_44 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla44, true);
            modelo.doc.cuerpo.cs_id_47 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla47, true);
            modelo.doc.cuerpo.cs_id_48 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla48, true);
            modelo.doc.cuerpo.cs_id_51 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla51, true);
            // modelo.doc.cuerpo.cs_id_53 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla53, true);
            modelo.doc.cuerpo.cs_id_58 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla58, true);
            modelo.doc.cuerpo.cs_id_59 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla59, true);
            modelo.doc.cuerpo.cs_id_63 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla63, true);
            modelo.doc.cuerpo.cs_id_64 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla64, true);
            modelo.doc.cuerpo.cs_id_67 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla67, true);
            // modelo.doc.cuerpo.cs_id_69 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla69, true);
            modelo.doc.cuerpo.cs_id_74 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla74, true);
            modelo.doc.cuerpo.cs_id_76 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla76, true);
            modelo.doc.cuerpo.cs_id_80 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla80, true);
            modelo.doc.cuerpo.cs_id_81 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla81, true);
            modelo.doc.cuerpo.cs_id_84 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla84, true);
            // modelo.doc.cuerpo.cs_id_86 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla86, true);
            modelo.doc.cuerpo.cs_id_98 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla98, true);
            modelo.doc.cuerpo.cs_id_99 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla99, true);
            modelo.doc.cuerpo.cs_id_100 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla100, true);
            modelo.doc.cuerpo.cs_id_102 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla102, true);
            modelo.doc.cuerpo.cs_id_104 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla104, true);
            modelo.doc.cuerpo.cs_id_105 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla105, true);
            modelo.doc.cuerpo.cs_id_107 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla107, true);
            modelo.doc.cuerpo.cs_id_108 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla108, true);
            modelo.doc.cuerpo.cs_id_110 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla110, true);
            modelo.doc.cuerpo.cs_id_112 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla112, true);
            modelo.doc.cuerpo.cs_id_123 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla123, true);
            modelo.doc.cuerpo.cs_id_124 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla124, true);
            modelo.doc.cuerpo.cs_id_125 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla125, true);
            modelo.doc.cuerpo.cs_id_131 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla131, true);
            modelo.doc.cuerpo.cs_id_132 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla132, true);
            modelo.doc.cuerpo.cs_id_133 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla133, true);
            modelo.doc.cuerpo.cs_id_134 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla134, true);
            //////////////////////////////////////////////////////////
            ////Agregado Factura Renta 18-08-2022
            modelo.doc.cuerpo.cs_id_38 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla38, true);
            modelo.doc.cuerpo.cs_id_45 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla45, true);
            modelo.doc.cuerpo.cs_id_50 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla50, true);
            modelo.doc.cuerpo.cs_id_56 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla56, true);
            modelo.doc.cuerpo.cs_id_60 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla60, true);
            modelo.doc.cuerpo.cs_id_62 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla62, true);
            modelo.doc.cuerpo.cs_id_66 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla66, true);
            modelo.doc.cuerpo.cs_id_72 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla72, true);
            modelo.doc.cuerpo.cs_id_75 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla75, true);
            modelo.doc.cuerpo.cs_id_77 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla77, true);
            modelo.doc.cuerpo.cs_id_79 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla79, true);
            modelo.doc.cuerpo.cs_id_83 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla83, true);
            modelo.doc.cuerpo.cs_id_89 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla89, true);
            modelo.doc.cuerpo.cs_id_94 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla94, true);
            modelo.doc.cuerpo.cs_id_95 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla95, true);
            modelo.doc.cuerpo.cs_id_96 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla96, true);
            modelo.doc.cuerpo.cs_id_109 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla109, true);
            modelo.doc.cuerpo.cs_id_112 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla112, true);
            modelo.doc.cuerpo.cs_id_113 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla113, true);
            modelo.doc.cuerpo.cs_id_114 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla114, true);
            modelo.doc.cuerpo.cs_id_115 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla115, true);
            modelo.doc.cuerpo.cs_id_121 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla121, true);
            modelo.doc.cuerpo.cs_id_127 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla127, true);
            modelo.doc.cuerpo.cs_id_128 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla128, true);
            modelo.doc.cuerpo.cs_id_129 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla129, true);

            //Campos agregados 210 v18
            modelo.doc.cuerpo.cs_id_130 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla130, true);
            modelo.doc.cuerpo.cs_id_355 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla355, true);
            modelo.doc.cuerpo.cs_id_297 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla297, true);
            if(Number(modelo.doc.cuerpo.cs_id_297)>0)modelo.doc.cuerpo.cs_id_299 ='1';
 
            /////Agrega casillas sugerida nube cas 245 y cas 246
            ///30-06-2026
            modelo.doc.cuerpo.cs_id_246 = this.dutilidadesMat.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla246, true);
            if(Number(modelo.doc.cuerpo.cs_id_246)>0)modelo.doc.cuerpo.cs_id_245 ='1';
         return modelo;
    }

    public obtenerValorUVTIngreso(anioDeclaracion,modelo: DDocumento){
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
        anioDeclaracion = (modelo.doc.cuerpo.cs_id_27 && (modelo.doc.cuerpo.cs_id_27 == "1" ||modelo.doc.cuerpo.cs_id_27 == "true"))? Number(anioDeclaracion) + 1 : anioDeclaracion;
        this.dBasicosParametricasServicios.obtenerValorPeriodico(110,Number(anioDeclaracion)).subscribe( //110 es el codigo de UVT
          res=>{
               
                let valorPeriodico = <DValorPeriodico>res;
                let UVT = String(valorPeriodico.valor);
                 ////Limpia dependientes
                modelo.doc.cuerpo.cs_id_241 =''; modelo.doc.cuerpo.cs_id_242 = ''; modelo.doc.cuerpo.cs_id_244 ='';
                modelo.doc.cuerpo.cs_id_287 =''; modelo.doc.cuerpo.cs_id_288 = ''; modelo.doc.cuerpo.cs_id_289 ='';
                modelo.doc.cuerpo.cs_id_290 =''; modelo.doc.cuerpo.cs_id_291 = ''; modelo.doc.cuerpo.cs_id_292 ='';
                modelo.doc.cuerpo.cs_id_293 =''; modelo.doc.cuerpo.cs_id_294 = ''; modelo.doc.cuerpo.cs_id_295 ='';
                /////////////////////////////////////////////////////
                modelo = this.dSerivicoFormulario210.calcularOperacionesSugerida(modelo,UVT);
                modelo.doc.cuerpo.cs_id_343 =  (this.extemporaneidad.impuestoNetoAnterior) ? `${this.extemporaneidad.impuestoNetoAnterior}` : '0';
                modelo.doc.cuerpo.cs_id_342 =  (this.extemporaneidad.numeroAnnios) ? `${this.extemporaneidad.numeroAnnios}` : '0';
                
                this.dSerivicoFormulario210.setModelo(modelo);
                this.dSerivicoFormulario210.operacionCs134();
                modelo = this.dSerivicoFormulario210.getModelo();
                console.log("______________________________________________Modelo Original: ", modelo);
                if (this.extemporaneidad.esExtemporaneo && !modelo.doc.cuerpo.cs_id_26) {
                   // this.mostrarDialogoExtemporaneidad(modelo);
                } else {
                    this.guardarActualizarBorrador(modelo);
                }
                precargaProceso.close();
            },error=>{
                precargaProceso.close();
                this.codBorradorSugerida.estadoUX='error';
                this.codBorradorSugerida.ideDocumento = null;
                this.codBorradorSugerida.saldoaPagar =  null;
                this.codBorradorSugerida.saldoaFavor =  null;
                this.codBorradorSugerida.pdfDocumento = null;
            }
        );    
    }

     /**
    * @desc Funcion para guardar o actualizar el borrador del formulario
    */
     protected guardarActualizarBorrador(modelo:DDocumento) {
        let modeloBorrador: DDocumento = modelo;
        let codBorradorSugerida: DCodBorradorSugerida = new DCodBorradorSugerida();
        modeloBorrador.doc.pie.cs_id_980 = modeloBorrador.doc.pie.cs_id_980 ? modeloBorrador.doc.pie.cs_id_980 : 0;
        modeloBorrador = this.transformarDatosModeloParaEnviar(modeloBorrador);
        if(!this.actividadEconomica)    
            modeloBorrador.doc.cuerpo.cs_id_24='0010';
        else
            modeloBorrador.doc.cuerpo.cs_id_24=this.actividadEconomica;
        modeloBorrador.doc.cuerpo.cs_id_285='';
        modeloBorrador.doc.cuerpo.cs_id_286='';
      //  modeloBorrador.doc.cuerpo.cs_id_303='';
        modeloBorrador.doc.pie.cs_id_983='';
        modeloBorrador.doc.pie.cs_id_997='';
       
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
        let observableServicio = this.dRenta210v18Servicios.crearFormulario(modeloBorrador, 'inicial');
        let modeloGuardado=new DDocumento();
        observableServicio.subscribe(
            res => {
                modeloGuardado = <DDocumento>res;
                this.imprimirFormularioBLOB(modeloGuardado)
                this.logger.info(DMensajes.BORRADOR_GUARDADO);
                precargaProceso.close();
            },
            error => {
                precargaProceso.close();
                this.codBorradorSugerida.estadoUX='sinSugerida';
                this.codBorradorSugerida.ideDocumento = null;
                this.codBorradorSugerida.saldoaPagar =  null;
                this.codBorradorSugerida.saldoaFavor =  null;
                this.codBorradorSugerida.pdfDocumento = null;
                this.redireccionarSugerida(this.codBorradorSugerida.estadoUX);
            }
        );
    }

    public transformarDatosModeloParaEnviar<T>(documento:DDocumento):DDocumento {
        let keys:Array<DItemConfiguracion> = [//modelo ejemplo
            {casilla: 'cs_id_27', tipoDato:'string', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_28', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_29', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_30', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_31', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_32', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_33', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_34', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_35', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_36', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_37', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_38', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_39', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_40', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_41', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_42', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_43', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_44', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_45', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_46', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_47', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_48', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_49', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_50', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_51', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_52', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_53', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_54', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_55', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_56', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_57', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_58', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_59', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_60', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_61', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_62', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_63', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_64', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_65', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_66', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_67', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_68', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_69', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_70', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_71', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_72', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_73', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_74', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_75', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_76', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_77', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_78', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_79', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_80', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_81', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_82', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_83', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_84', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_85', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_86', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_87', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_88', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_89', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_90', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_91', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_92', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_93', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_94', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_95', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_96', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_97', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_98', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_99', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_100', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_101', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_102', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_103', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_104', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_105', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_106', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_107', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_108', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_109', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_110', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_111', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_112', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_113', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_114', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_115', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_116', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_117', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_118', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_119', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_120', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_121', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_122', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_123', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_124', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_125', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_126', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_127', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_128', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_129', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_130', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_131', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_132', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_133', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_134', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_135', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_136', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_137', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_138', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_139', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_141', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_241', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_242', tipoDato:'string', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_244', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_245', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_246', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_247', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_248', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_249', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_250', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_251', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_252', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_253', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_254', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_255', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_256', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_265', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_266', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_267', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_270', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_271', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_272', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_273', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_274', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_275', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_276', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_277', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_278', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_279', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_280', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_281', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_282', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_287', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_288', tipoDato:'string', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_289', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_290', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_291', tipoDato:'string', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_292', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_293', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_294', tipoDato:'string', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_295', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_296', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_297', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_298', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_299', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_300', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            ///revisar
            {casilla: 'cs_id_301', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_302', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            /////
            {casilla: 'cs_id_303', tipoDato:'string', redondear: false, editable: true,  validaciones:{}},
            {casilla: 'cs_id_304', tipoDato:'number', redondear: false, editable: true,  validaciones:{}},
            {casilla: 'cs_id_305', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_306', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_307', tipoDato:'number', redondear: false, editable: true,  validaciones:{}},
            {casilla: 'cs_id_308', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_309', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_310', tipoDato:'number', redondear: false, editable: true,  validaciones:{}},
            {casilla: 'cs_id_311', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_312', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_313', tipoDato:'number', redondear: false, editable: true,  validaciones:{}},
            {casilla: 'cs_id_314', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_315', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_316', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_317', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_318', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_319', tipoDato:'number', redondear: false, editable: true,  validaciones:{}},
            {casilla: 'cs_id_320', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_321', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_322', tipoDato:'number', redondear: false, editable: true,  validaciones:{}},
            {casilla: 'cs_id_323', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_324', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_325', tipoDato:'number', redondear: false, editable: true,  validaciones:{}},
            {casilla: 'cs_id_326', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_327', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_328', tipoDato:'number', redondear: false, editable: true,  validaciones:{}},
            {casilla: 'cs_id_329', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_330', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_331', tipoDato:'number', redondear: false, editable: true,  validaciones:{}},
            {casilla: 'cs_id_332', tipoDato:'number', redondear: true, editable: false,  validaciones:{}},
            {casilla: 'cs_id_333', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_334', tipoDato:'number', redondear: false, editable: true,  validaciones:{}},
            {casilla: 'cs_id_335', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_341', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_355', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_356', tipoDato:'number', redondear: true, editable: true,  validaciones:{}},
            {casilla: 'cs_id_357', tipoDato:'number', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_358', tipoDato:'string', redondear: false, editable: false,  validaciones:{}},
            {casilla: 'cs_id_359', tipoDato:'number', redondear: false, editable: false,  validaciones:{}}
        ];
        
        for(let i in keys){
                // Convierte una cadena con numeros en dato de tipo string, este se usa para datos cuya longitud supera la del number nativo
                    if(keys[i].tipoDato === 'number') {
                        if(keys[i].redondear){
                            documento.doc.cuerpo[keys[i].casilla] = this.dutilidadesMat.redondearValorMoneda(documento.doc.cuerpo[keys[i].casilla], false);     
                        } else {
                            documento.doc.cuerpo[keys[i].casilla] = this.dutilidadesMat.deshacerFormatoMoneda(documento.doc.cuerpo[keys[i].casilla]);      
                        }
                    }  
            }
        return documento;
    }


    private obtenerActividadEconomicas(nit:string){
        let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
      this.dRutServicios.consultarActividadesEconomicasContribuyente(nit).subscribe(
          res1 => {
          
          if ( res1.hasOwnProperty('0') ){
              let actividadesEconomica:any = res1;
              this.actividadEconomica = actividadesEconomica[0].id
              
        }          
          precargaProceso.close();
      }, error =>{
          this.dNotificacionServicio.mostrarDialogoError("Error obteniendo parametros del contribuyente: Actividad Economica");
          precargaProceso.close();
      });
    }


redireccionarSugerida(estadoSugerida =''){
    let seccion = 'sugerida';
    switch (estadoSugerida) {
        case 'presentada':
            seccion = 'presentados'
            break;
        case 'borrador':
            seccion = 'borradores'
            break;
        case 'sugerida':
            seccion = 'sugerida'
            break;
        case 'sinSugerida':
            seccion = 'crearFormulario'
            break;
        default:
            break;
    }
    this.router.navigate(['ingreso', seccion], {queryParams: {idRequest: this.paramValue}});
}


  private construirMenu() {
    this.cards = [
      {
        titulo: 'Inicio',
        active: true,
        icono: 'inicio',
        link: '/ingreso',
        iconowhite: 'b-inicio',
        visible: true
      },
      {
        titulo: 'Haga su declaración de renta',
        active: false,
        icono: 'crear',
        link: '/ingreso/crearFormulario',
        iconowhite: 'crear-white',
        visible: true
      },
      {
        titulo: 'Edite su declaración de renta',
        active: false,
        icono: 'tareas',
        link: '/ingreso/borradores',
        iconowhite: 'tareas-white',
        visible: true
      },
      {
        titulo: 'Presente declaración de renta por fracción de año',
        active: false,
        icono: 'agregar-fecha',
        link: '/ingreso/fraccion',
        iconowhite: 'agregar-fecha-white',
        visible: true
      },
      {
        titulo: 'Formularios definitivos listos para presentación',
        active: false,
        icono: 'definitivos',
        link: '/ingreso/definitivos',
        iconowhite: 'definitivos-white',
        visible: true
      },
      {
        titulo: 'Declaraciones de renta presentadas',
        active: false,
        icono: 'presentados',
        link: '/ingreso/presentados',
        iconowhite: 'presentados-white',
        visible: true
      },
      {
        titulo: 'Pago por cuotas',
        active: false,
        icono: 'pago-cuotas',
        link: '/ingreso/cuotas',
        iconowhite: 'pago-cuotas-white',
        visible: true
      },
    /*  {
        titulo: 'Devolución de saldo a favor',
        active: false,
        icono: 'devoluciones',
        link: 'http://10.255.5.224:4200/devoluciones/validador/proceso/4',
        iconowhite: 'devoluciones-white',
        visible: true
      }*/
    ];
  }

  public hideItemDescription(){
    this.show_item_description = false;
  }

  public showItemDescription(){
    this.show_item_description = true;
  }

  redirect(item){
    item.link ? this.router.navigate([item.link]) : this.router.navigate(['/']);;
  }

  /**
    * @desc Funcion para conocer si el contribuyente tiene firma electronica
    * @param {String} ideDocumento
    */
  public consultarFirmanteElectronico(ideDocumento:string) {
    let observableServicio = this.operacionesGenerales.consultarFirmanteElectronico(ideDocumento);
    observableServicio.subscribe(
        res => {
            this.esFirmanteElectronico = <DFirmaElectronica>res;
            this.firmaRequerida = this.esFirmanteElectronico.esFirmaElectronica;
            this.verificarFirmaYTipoContribuyente('firmaElectronica');
            if (this.configuracionFormulario.USA_CERTIFICADO_FIRMA_OBLIGATORIO && !this.firmaRequerida) {                       
                let dialogFirma = this.dNotificacionServicio.mostrarDialogoError(DMensajes.SIN_FIRMA_ELECTRONICA);
                dialogFirma.afterClosed().subscribe(result => {
                    this.operacionesGenerales.irPaginaDashboard(); 
                });                        
            } else {
                this.enProceso = true;
                let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
                let definitivos = this.configuracionFormulario.USA_CERTIFICADO_FIRMA_OBLIGATORIO;
                this.obtenerDocs(definitivos ? false : true); 
                this.obtenerIdentidad();  
                this.obtenerAnios(); 
                this.obtenerFechaInscripcionRUT(); 
                this.validarCargaCompletaFormulario(precarga);  
                this.obtenerVersionesRuta(this.configuracionFormulario.NUMERO_FORMULARIO);     
                this.consultarSaldoDevoluciones();               
            }                    
        }
    );            
} 

showWarningDialog() {
    let message = 'Para agilizar y facilitar su trámite de declaración de renta, le recomendamos generarla.';
    let infoMessage = '<p class="mb-0 text-center mt-0">La firma se activará aproximadamente, 10 minutos después de su generación.</p>';
    const configBody = {
      title: 'No tiene firma electrónica',
      message: message,
      main_button: "Generar firma",
      secondary_button: "Continuar sin firma",
      info_message: infoMessage, 
      main_action: "accept",
      text_align: "text-center",
      button_align: 'text-center',
      width: '350',
      secondaryButtonClass: 'form-control',
      mainButtonClass: 'form-control mt-2',
      onMainAction: ()=>{window.location.href = `${window.location.origin}/WebDashboard/DefDashboard.faces`;},
      onSecondaryAction: ()=>{if(this.sugerida) this.consultarExtemporaneidad()}
     }
     this.modalService.show(ModalType.SUCESS, configBody)
}

/**
* @desc Funcion para validar si el formulario esta completamente cargado y remover la animacion de precarga
* @ignore
*/
private validarCargaCompletaFormulario(precarga) {
    let intervalId = setInterval(()=>{
        let bandera = true;
        let atributos = Object.keys(this.estadosCarga);

        for(let i in atributos){
            if(!this.estadosCarga[atributos[i]]){
                bandera = false;
                break;
            }
        }

        if(bandera){
            this.enProceso = true;
            precarga.close();
            clearInterval(intervalId);  
        }                        
    }, 500);
}

/**
* @desc Funcion para obtener los aÃ±os
*/
private obtenerAnios() {
    let observableServicio = this.dServicioRESTAPI.consultarAniosFormato();
    observableServicio.subscribe(
        res => {
            this.logger.info("Obteniendo Años ", res);
            this.aniosFormato = <DAniosFormato>res;               
            let anios:Array<number>=[];
            this.aniosFormato.anios.forEach((anio) =>{
                if(Number(anio)>2016){
                    anios.push(anio);
                } else this.mostrarOtros = true;
            });
            this.aniosFormato.anios=anios;
            if (this.aniosFormato.anios.length === 1) {
                this.anioSeleccionado = this.aniosFormato.anios[0];
                this.obtenerPeriodicidad(this.anioSeleccionado);
            }                

            this.estadosCarga.anios = true;             
        },
        error => {
            this.estadosCarga.anios = true;
            this.dNotificacionServicio.mostrarDialogoError("No se obtuvo información de la lista de años. Refresque la página.");
        }
    );
}

public redireccionarSelectorFlex() {
    window.location.href = `${window.location.origin}/WebDiligenciamiento/DefDiligenciamientoFormularios.faces?form=${this.configuracionFormulario.NUMERO_FORMULARIO}`
}

/**
* @desc Funcion para construir el listado de los años para fraccion de año
*/

private obtenerAniosFraccion() {
    let anioActual = (new Date()).getFullYear();
    this.aniosFraccion.push(String(anioActual));
}

/**
* @desc Funcion para verificar si el formulario debe de mostrar la seccion de fraccion de año
* @param {Number} anio
*/
private verificarFraccionAnio(anio:number) {
    let anioActual = (new Date()).getFullYear();
    this.fraccionAnio = (Number(anio) >= anioActual) ? true :false;          
}

/**
* @desc Funcion para obtener la periodicidad
*/
private obtenerPeriodicidad(anio:number) {
    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    let observableServicio = this.dServicioRESTAPI.consultarListaPeriodicidad(anio);
    observableServicio.subscribe(
        res => {
            this.logger.info("Obteniendo Periodicidad ", res);
            this.periodicidadFormato = <DPeriodicidadFormato>res;
            if (this.periodicidadFormato.listaPeriodicidades.length === 1) {
                this.periodicidadSelecionada = this.periodicidadFormato.listaPeriodicidades[0].nombre;
                this.obtenerPeriodos(this.anioSeleccionado, this.periodicidadSelecionada);
            }
            precarga.close();
        },
        error => {
            precarga.close();
            this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la lista de periodicidades.");
        }
    );
}

/**
* @desc Funcion para obtener los periodos
*/
private obtenerPeriodos(anio:number, periodicidad:string) {
    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    let observableServicio = this.dServicioRESTAPI.consultarListaPeriodos(anio, periodicidad);
    observableServicio.subscribe(
        res => {
            this.logger.info("Obteniendo Periodos ", res);
            this.periodosFormato = <DPeriodoFormato>res;
            if (this.periodosFormato.listaPeriodos.length === 1) {
                this.periodoSeleccionado = this.periodosFormato.listaPeriodos[0];
                this.validarActivarBotonPagoCuotas();
            }
            precarga.close();
        },
        error => {
            precarga.close();
            this.dNotificacionServicio.mostrarDialogoError("Error obteniendo la lista de periodos."); 
        }
    );
}    

/**
* @desc Funcion para obtener los documentos pendientes y presentados
* @param {boolean} definitivos
*/
public obtenerDocs(definitivos?: boolean) {        
    this.obtenerDocsPendientes();
    this.obtenerDocsPresentados();
    if( definitivos) {
        this.obtenerDocsDefinitivos();
    } else {
        this.estadosCarga.definitivos = true;
    }
   // this.consultarSaldoDevoluciones();     
}

/**
* @desc Funcion para obtener los documentos pendientes
*/
public obtenerDocsPendientes() {
    let observableDiligenciamiento = this.dServicioRESTAPI.consultarFormulariosEstado('pendiente'); 
    observableDiligenciamiento.subscribe(
        res => {            
            this.logger.info("Obteniendo Documentos Pendientes ", res);                
            this.arrDocumentosDiligenciamiento = <DListaDocumentos>(res.listadoFormularios);             
            this.arrDocumentosDiligenciamiento.infoFormularios.forEach((item, index) => {
                if (item.modo === 'fraccion' || item.modo === 'fraccion_correccion'){
                    this.hayFraccion = true;
                }
                if (item.modo === 'inicial' || item.modo === 'correccion') {
                    this.hayInicial = true;                        
                }
            });
            this.estadosCarga.pendientes = true;
        },
        error => {
            this.estadosCarga.pendientes = true;
        }
    );
}

/**
* @desc Funcion para obtener los documentos Definitivos
*/
public obtenerDocsDefinitivos(){
    let observablePresentados = this.dServicioRESTAPI.consultarFormulariosEstado('definitivo');
    observablePresentados.subscribe(
        res => {
            this.logger.info("Obteniendo Documentos Definitivos ", res);
            this.arrDocumentosDefinitivos = <DListaDocumentos>(res.listadoFormularios);
            this.estadosCarga.definitivos = true;                           
        },
        error => {
            this.estadosCarga.definitivos = true;   
        }
    );
}

/**
* @desc Funcion para obtener los documentos Presentados
*/
public obtenerDocsPresentados(){
    let observablePresentados = this.dServicioRESTAPI.consultarFormulariosEstado('presentado');
    observablePresentados.subscribe(
        res => {
            this.logger.info("Obteniendo Documentos Presentados ", res); 
            this.arrDocumentosPresentados =<DListaDocumentos>(res.listadoFormularios); //.infoFormularios; //<DListaDocumentos>(res.infoFormularios);
            this.arrencabezadoPieForm = res.idetificadoresDocumentos;
           // Array<DIdentificadorDocumento>(res.idetificadoresDocumentos);
            this.arrDocumentosFactura = <DListaDocumentos>JSON.parse(JSON.stringify(this.arrDocumentosPresentados));
           // let identificadorDoc:DIdentificadorDocumento=new DIdentificadorDocumento();
            for( let identificadorDoc of (Array)(this.arrencabezadoPieForm))
                {
                    //let lidentificador:DIdentificadorDocumento =<DIdentificadorDocumento>identificadorDoc;
                    //let lidentificador =identificadorDoc;
                    let contador=0;
                    //this.logger.info("Tamaño de los identificadores del documento ",(Array)(identificadorDoc.links).length);
                    for( let lidentificador1 of identificadorDoc)
                    {   
                        
                        let claveNegocio : string  =lidentificador1.cadClaveNegocio;
                        let ideDocumento = lidentificador1.idDocumento;
                        let valoresCasilla : string[] = claveNegocio.split(';');
                        let casilla285 = valoresCasilla[3].split('=')
                        if(casilla285[0]=='285')
                        {
                            let valcasilla285:string=casilla285[1];
                            //let valcasilla285:string='false';
                            if(valcasilla285=='true')
                            {   
                                let count=0;
                                for(let ldocumento of this.arrDocumentosPresentados.infoFormularios) 
                                {   
                                    if(ideDocumento==ldocumento.identificador.id)
                                    {
                                        this.arrDocumentosPresentados.infoFormularios.splice(count,1); 
                                        break;
                                    }
                                    count++;
                                }
                                

                            }
                            else
                            {   
                                let count=0;
                                for(let ldocumento of this.arrDocumentosFactura.infoFormularios) 
                                {   
                                    if(ideDocumento==ldocumento.identificador.id)
                                    {
                                        this.arrDocumentosFactura.infoFormularios.splice(count,1); 
                                        break;
                                        
                                    }
                                    count++;
                                }
                                
                                
                            }
                        }
                        else
                        {
                            let count=0;
                                for(let ldocumento of this.arrDocumentosFactura.infoFormularios) 
                                {   
                                    if(ideDocumento==ldocumento.identificador.id)
                                    {
                                        this.arrDocumentosFactura.infoFormularios.splice(count,1); 
                                        break;
                                        
                                    }
                                    count++;
                                }
                                
                                
                        }
                        contador++;
                    }

                }

                this.arrDocumentosPresentados.infoFormularios=this.arrDocumentosPresentados.infoFormularios.sort((a,b)=>a.anio-b.anio);
                
            this.estadosCarga.presentados = true;     
          
        },
        error => {
            this.estadosCarga.presentados = true;
            
        }
    );
}

/**
* @desc Funcion para obtener los datos de identidad
*/
private obtenerIdentidad(){
    let observableServicio = this.dContextoUsuarioServicio.consultarContextoUsuarioMuisca();     
    observableServicio.subscribe(
        res => {
            this.datosContexto = <DContextoMuisca>res;
            let datosRespuesta:DContextoMuisca = <DContextoMuisca>res;
            if(!this.datosContexto.NitUsuario){
               /* this.dServicioRESTAPI.consultarNit(Number(this.datosContexto.codigoUsuario)).subscribe(
                    res=>{
                        this.datosContexto.NitUsuario = <string>res['text'];
                        this.obtenerActividadEconomicas(this.datosContexto.NitUsuario)
                        if (!this.esFirmanteElectronico.esFirmaElectronica) {
                            this.showWarningDialog()
                        } else if(this.sugerida) {
                            this.consultarExtemporaneidad();
                        }
                        datosRespuesta.NitUsuario = <string>res['text'];
                        this.validarAccesoFormato(210, 18, Number(datosRespuesta.NitUsuario), this.modoUsoFraccion210v16);
                        this.consultarTipoContribuyente(datosRespuesta.ANombrePropio ? datosRespuesta.NitUsuario : datosRespuesta.NitOrganizacion);
                    },error=>{
                        this.dNotificacionServicio.mostrarDialogoError("Error obteniendo Nit");
                        this.logger.error('Error obteniendo nit');
                    }
                );*/
                this.dContextoUsuarioServicio.consultarContextoUsuarioMuisca().subscribe(
                    (res: DContextoMuisca) => {
                    const contexto = <DContextoMuisca>JSON.parse(sessionStorage.getItem('DIAN-MUISCATK'));
                    if (!contexto) {
                      return;
                    }
                    this.datosContexto.NitUsuario= (datosRespuesta.ANombrePropio) ?<string>contexto.NitUsuario : <string>contexto.NitOrganizacion;
                    this.obtenerActividadEconomicas(this.datosContexto.NitUsuario)
                        if (!this.esFirmanteElectronico.esFirmaElectronica) {
                            this.showWarningDialog()
                        } else if(this.sugerida) {
                            this.consultarExtemporaneidad();
                        }
                        datosRespuesta.NitUsuario = <string>contexto.NitUsuario;
                        this.validarAccesoFormato(210, 18, Number(datosRespuesta.NitUsuario), this.modoUsoFraccion210v16);
                        this.consultarTipoContribuyente(datosRespuesta.ANombrePropio ? datosRespuesta.NitUsuario : datosRespuesta.NitOrganizacion);
                });
            }else{
                this.obtenerActividadEconomicas(this.datosContexto.NitUsuario)
                if (!this.esFirmanteElectronico.esFirmaElectronica) {
                    this.showWarningDialog()
                } else if(this.sugerida) {
                    this.consultarExtemporaneidad();
                }
                this.consultarTipoContribuyente(datosRespuesta.ANombrePropio ? datosRespuesta.NitUsuario : datosRespuesta.NitOrganizacion);
                this.validarAccesoFormato(210, 17, Number(datosRespuesta.NitUsuario), this.modoUsoFraccion210v16);
            }                                 
        },                     
        error =>{  
            this.dNotificacionServicio.mostrarDialogoError(DMensajes.ERROR_CON_IDENTIDAD);                      
        }
    );    
}

/**
* @desc Funcion para crear un nuevo borrador
* @param {String} concepto
*/
public crearNuevoBorrador(concepto: String, modoNoExperto = false) {                   
    // mensual, bimestral, cuatrimestral, anual, aperiodico
    let queryStringParams;
    const modo = modoNoExperto ? 'no-experto' : 'experto';
    if (concepto === 'inicial') {
        if(this.existenBorradoresDefinitivosInicial){
            this.copiarFormulario(this.arrDocumentosDefinitivos.infoFormularios[0],true);
        }
        else{            
            queryStringParams = {
                concepto: concepto, 
                anio: this.anioSeleccionado, 
                periodicidad: this.periodicidadSelecionada?this.periodicidadSelecionada:"anual", 
                periodo: (this.periodoSeleccionado && this.periodoSeleccionado.id) ? this.periodoSeleccionado.id : "1",
                modo: modo
            };
        }
    } else {
        if(this.existenBorradoresDefinitivosFraccion){
            this.copiarFormulario(this.arrDocumentosDefinitivos.infoFormularios[0],true);
        }
        else{            
            queryStringParams = {
                anio: this.anioSeleccionadoFraccion,
                //anio: (this.anioSeleccionadoFraccion - 1),
                concepto: concepto,
                periodicidad: "anual", 
                periodo: "1",
                modo: modo            
            };
        }
    }
    
    let params = this.dutilidades.getQueryStringParams(queryStringParams, false);   
    //window.location.href = location.origin + '/formulario?' + params; 
    //this.router.navigate(['/formulario'], { queryParams: queryStringParams });
    this.enProceso = true;

    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
    let indModoFraccion = concepto == "fraccion" ? "S" : "N" ;
    let observableVersionFormato = this.dServicioRESTAPI.obtenerVersionDocumento(queryStringParams.anio, queryStringParams.periodicidad, queryStringParams.periodo, indModoFraccion);
    observableVersionFormato.subscribe(
        res => {
            let version = <DVersionRutaFormato>res;       
            precargaProceso.close();
            this.enProceso = false;  
            this.logger.info("URL Crear nuevo borrador: ", location.origin + version.urlFormato + 'v' + version.version + '?' + params);                
            this. redirigirFormulario(version,params); 
        },
        error => {
            precargaProceso.close();
            this.enProceso = false;
            this.dNotificacionServicio.mostrarDialogoPersonalizado("Advertencia","El formulario solicitado no esta disponible para su diligenciamiento.",null,null,null,null);
        }
    );        
}

/**
* @desc Funcion para consultar el tipo de contribuyente
* @param {string} nit del contribuyente
*/
public consultarTipoContribuyente(nit: string) {
    let observableServicio = this.dRutServicios.consultarTipoContribuyente(nit);
    observableServicio.subscribe(
        res => {
            this.tipoContribuyente = <DTipoContribuyente>res;
            this.constribuyenteId = this.tipoContribuyente.id; 
            this.verificarFirmaYTipoContribuyente('tipoContribuyente');          
        },
        error => {
            this.dNotificacionServicio.mostrarDialogoError(DMensajes.ERROR_OBTENIENDO_CONTRIBUYENTE);                
        }
    );
} 

verificarFirmaYTipoContribuyente(consulta: string) {
    if(consulta === 'tipoContribuyente') {
        this.tipoContribuyenteConsultado = true;
    } else if (consulta === 'firmaElectronica') {
        this.firmaElectronicaConsultada = true;
    }
    if (this.tipoContribuyenteConsultado && this.firmaElectronicaConsultada ) {
        this.generalServcice.setDatosFirmaYGranContribuyente({esFirmaElectronica: this.esFirmanteElectronico.esFirmaElectronica, granContribuyente: this.tipoContribuyente.granContribuyente});
        if (!this.esFirmanteElectronico.esFirmaElectronica || !this.tipoContribuyente.granContribuyente) {
            const pagoPorCuotasCard = this.cards.find(item => item.titulo === 'Pago por cuotas');
            if (pagoPorCuotasCard) pagoPorCuotasCard.visible = false;
        }
        if (this.esFirmanteElectronico.esFirmaElectronica) {
            const definitivosCard = this.cards.find(item => item.titulo === 'Formularios definitivos listos para presentación');
            if (definitivosCard) definitivosCard.visible = false;
        }
    }
}

/**
* @desc Funcion para imprimir el formulario
*/
public imprimirFormulario(idFormulario:string) {
    this.operacionesGenerales.imprimirFormulario(idFormulario);      
}

/**
* @desc Funcion para pagar el formulario
* @param {String} idFormulario
* @param {String} anioGravable
* @param {String} periodo
* @param {DInfoResumenFormulario} objetoFormulario
*/
public pagarFormulario(idFormulario:string, anioGravable:string, periodo:string, objetoFormulario:DInfoResumenFormulario) {
    if (this.configuracionFormulario.USA_FORMULARIO_PAGO_NUEVO) {
        let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
        let observableServicio = this.dServicioRESTAPI.generarLiquidacionReciboPago(idFormulario);
        observableServicio.subscribe(
            res => {
                precarga.close();
                let liquidacion:DLiquidacionRecibo;
                if(Number(anioGravable)>=2023)
                {
                    liquidacion = <DLiquidacionRecibo>res.dliquidacionReciboTO;
                    if(res.aporteVoluntario && res.aporteVoluntario!=null && res.aporteVoluntario !='')
                    {
                    this.aporteVoluntario = Number(res.aporteVoluntario);
                    if( this.aporteVoluntario<=0)
                        liquidacion.conceptos.splice(1);
                    else
                    {
                        this.dNotificacionServicio.mostrarDialogoInformacion("Señor(a) usuario(a) <br>Usted digito la casilla 141 de aporte Voluntario, por favor genere recibo de pago 490, concepto 45");
                        liquidacion.aporteVoluntario=""+this.aporteVoluntario;
                        liquidacion.impuestoconVoluntario=JSON.parse(JSON.stringify(liquidacion.totalValorMonetario.impuesto));
                        liquidacion.totalConVoluntario=JSON.parse(JSON.stringify(liquidacion.totalValorMonetario.totalPagar));
                    }
                    }
                    else
                     liquidacion.conceptos.splice(1);
                    
                }
                else{
                    liquidacion = <DLiquidacionRecibo>res;
                }
             /*   let concepto:DConceptoLiquidacionRecibo = new DConceptoLiquidacionRecibo();
                concepto.id = '4';
                concepto.nombre = "RENTA";
                let conceptos:Array<DConceptoLiquidacionRecibo> = new Array<DConceptoLiquidacionRecibo>();
                conceptos.push(concepto);
                liquidacion.conceptos = conceptos;*/
              //  if (liquidacion) this.dReciboPagoServicio.mostrarDialogoReciboPago(this.datosContexto,this.firmaRequerida, liquidacion,null,null,true);
              if (liquidacion) this.generalServcice.enviarDatosReciboPago({contexto: this.datosContexto, tieneFirmaElectronica: this.firmaRequerida, liquidacion: liquidacion, fecha: null, mensajeAntesGuardar: null, pagoPSE: true})

            },
            error => {
                precarga.close();
                 this.dNotificacionServicio.mostrarDialogoError('No es posible generar el recibo de pago');
            }
        );    
    } else {
        let modelo = new DDocumento();
        modelo.doc.cab.cs_id_4 = idFormulario;
        modelo.doc.cab.cs_id_1 = anioGravable;
        modelo.doc.cab.cs_id_3 = periodo ? periodo : "1"; 
        let contribuyente = this.tipoContribuyente.granContribuyente ? '3' : this.constribuyenteId;
        let atributos = objetoFormulario.atributos.docAtributos;
        let tipoDoc = atributos.esDefinitivo ? '2' : atributos.esPresentado ? '5' : null;
        this.operacionesGenerales.pagarFormulario(modelo, contribuyente, this.configuracionFormulario.NUMERO_FORMULARIO, tipoDoc);
    }   
}  

private pagarFormularioINIT(id, anio, periodo, modo, item){
    let arrayButtons = [
        {text: 'SI/YES', value: "COP", mdClass: 'warn', disabled: false} ,
        {text: 'NO', value: "USD", mdClass: 'warn', disabled: false}  
    ];
    let dialog_carga = this.dNotificacionServicio.mostrarDialogoPersonalizado('<b>ES:</b> ¿Realizará el pago en pesos colombianos? </br> <b>EN:</b> Will you make the payment in Colombian pesos?', "", "",arrayButtons,null,null,null);
        dialog_carga.afterClosed().subscribe(
            result => {
                let lannioGravable=anio;
                if(result==="USD"){
                    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
                    let observableServicio = this.dServicioRESTAPI.generarLiquidacionReciboPagoExterior(id);
                    observableServicio.subscribe(
                        res => {
                            precarga.close();
                            let liquidacion = <DLiquidacionReciboExterior>res;                                
                            if (liquidacion) this.dReciboPagoExteriorDialogoServicio.mostrarDialogoReciboPago(this.datosContexto, this.firmaRequerida, liquidacion, null, null, true);
                        },
                        error => {
                            precarga.close();
                            this.dNotificacionServicio.mostrarDialogoError('No es posible generar el recibo de pago');                     
                        }
                    );  
                }
                if(result==="COP"){
                     if(this.fraccionAnio)
                     {
                        lannioGravable = anio + 1;
                     }                       
                    this.pagarFormulario(id, lannioGravable, periodo,item);
                }
            }
        ); 
}

/**
* @desc Funcion para editar el formulario
* @param {Object} objetoFormulario
*/
public editarFormulario(objetoFormulario:DInfoResumenFormulario, modoNoExperto = false){
    let esCorreccion:boolean = objetoFormulario.infoCorreccion.esCorreccion;
    let periodo = objetoFormulario.periodicidad === 'anual' ? 1 : objetoFormulario.periodo;
    let queryStringParams = null;
    if(objetoFormulario.modo == "fraccion" || objetoFormulario.modo == "fraccion_correccion") objetoFormulario.anio = objetoFormulario.anio + 1;
    const modo = modoNoExperto ? 'no-experto' : 'experto';
    if(esCorreccion) {
        queryStringParams = {
            concepto: objetoFormulario.modo,
            anio: objetoFormulario.anio, 
            periodicidad: objetoFormulario.periodicidad, 
            periodo: periodo,
            documento: objetoFormulario.infoCorreccion.ideDocumentoCorrige,
            modo: modo
        };            
    } else {           
        queryStringParams = {
            concepto: objetoFormulario.modo,
            anio: objetoFormulario.anio, 
            periodicidad: objetoFormulario.periodicidad, 
            periodo: periodo,
            idedocumento: objetoFormulario.identificador.id,
            modo: modo
        };
    }
    
    let params = this.dutilidades.getQueryStringParams(queryStringParams, false);


    //Version
    this.enProceso = true;
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    let anioVersion = Number(objetoFormulario.anio);      
    let periodoVersion = Number(periodo);
    let indModoFraccion = objetoFormulario.modo == "fraccion" || objetoFormulario.modo == "fraccion_correccion" ? "S" : "N";
    let observableVersionFormato = this.dServicioRESTAPI.obtenerVersionDocumento(anioVersion, objetoFormulario.periodicidad, periodoVersion, indModoFraccion);
    observableVersionFormato.subscribe(
        res => {
            let version = <DVersionRutaFormato>res;  
            precargaProceso.close();
            this.enProceso = false;
            this.logger.info("URL Editar formulario: ", location.origin + version.urlFormato + 'v' + version.version + '?' + params);                  
            this. redirigirFormulario(version,params);
        },
        error => {
            precargaProceso.close();
            this.enProceso = false; 
            if(objetoFormulario.modo == "fraccion" || objetoFormulario.modo == "fraccion_correccion") objetoFormulario.anio = objetoFormulario.anio - 1;           
            this.dNotificacionServicio.mostrarDialogoPersonalizado("Advertencia","El formulario solicitado no esta disponible para su diligenciamiento.",null,null,null,null);
        }
    ); 
}

/**
* @desc Funcion para consultar los formularios por aÃ±o gravable
* @param {Number} anio
*/
public consultarFormulariosPorAnio(anio:number){
    this.enProceso = true;
    this.anioSeleccionadoPresentados = anio;
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    let observableServicio = this.dServicioRESTAPI.consultarFormulariosEstado('presentado', anio); 
    observableServicio.subscribe(
        res => {
            this.arrDocumentosPresentados = <DListaDocumentos>(res.listadoFormularios);
            precargaProceso.close();
            this.enProceso = false; 
        },
        error => {
            precargaProceso.close();
            this.enProceso = false;
        }
    ); 

}

/**
* @desc Funcion para corregir un formulario presentado
* @param {DInfoResumenFormulario} objetoFormulario
*/
public corregirFormulario(objetoFormulario:DInfoResumenFormulario, modoNoExperto = false){  
    let esCorreccion = objetoFormulario.atributos.docAtributos.esPresentado ? 'correccion' : objetoFormulario.modo;
    esCorreccion = objetoFormulario.modo === "fraccion" || objetoFormulario.modo === "fraccion_correccion" ? "fraccion_correccion": esCorreccion;
    let periodo = objetoFormulario.periodicidad === 'anual' ? 1 : objetoFormulario.periodo;
    if(objetoFormulario.modo == "fraccion" || objetoFormulario.modo == "fraccion_correccion") objetoFormulario.anio = objetoFormulario.anio + 1;
    const modo = modoNoExperto ? 'no-experto' : 'experto';
    let queryStringParams = {
        concepto: esCorreccion,
        anio: objetoFormulario.anio, 
        periodicidad: objetoFormulario.periodicidad, 
        periodo: periodo ? periodo : "null",
        documento: objetoFormulario.identificador.id,
        modo: modo
    };
    let params = this.dutilidades.getQueryStringParams(queryStringParams, false);   

    //Version
    this.enProceso = true;
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
    let anioVersion = Number(objetoFormulario.anio);
    let periodoVersion = Number(periodo);
    let indModoFraccion = objetoFormulario.modo === "fraccion" || objetoFormulario.modo === "fraccion_correccion" ? "S" : "N";
    let observableVersionFormato = this.dServicioRESTAPI.obtenerVersionDocumento(anioVersion, objetoFormulario.periodicidad, periodoVersion, indModoFraccion);
    observableVersionFormato.subscribe(
        res => {
            let version = <DVersionRutaFormato>res;       
            precargaProceso.close();
            this.enProceso = false;    
            this.logger.info("URL Corregir formulario: ", location.origin + version.urlFormato + 'v' + version.version + '?' + params);              
            this. redirigirFormulario(version,params); 
        },
        error => {
            precargaProceso.close();
            this.enProceso = false;
            this.dNotificacionServicio.mostrarDialogoPersonalizado("Advertencia","El formulario solicitado no esta disponible para su diligenciamiento.",null,null,null,null);
        }
    ); 
}

/**
* @desc Funcion para copiar los formularios cuando son definitivos
* @param {DInfoResumenFormulario} objetoFormulario
*/
public copiarFormulario(objetoFormulario: DInfoResumenFormulario, newForm:boolean=false) {
    let ideDocumento = String(objetoFormulario.identificador.id);
    let modo = objetoFormulario.atributos.docAtributos.esPresentado ? 'correccion' : objetoFormulario.modo;
    //modo = objetoFormulario.modo === "fraccion" || objetoFormulario.modo === "fraccion_correccion" ? "fraccion_correccion": modo;
    if(objetoFormulario.identificador.versionFormato == 15) objetoFormulario.anio = 2019
    let anio = Number(objetoFormulario.anio);
    let periodicidad = objetoFormulario.periodicidad;
    let periodo = objetoFormulario.periodicidad === 'anual' || !objetoFormulario.periodo ? 1 : objetoFormulario.periodo;
    let indModoFraccion = objetoFormulario.modo === "fraccion" || objetoFormulario.modo === "fraccion_correccion" ? "S" : "N";
    let queryStringParams = {
            idedocumento: ideDocumento,
            concepto: modo, 
            anio: anio, 
            periodicidad: periodicidad, 
            periodo: periodo,
            clonar: true,
            nuevoForm: newForm
        }; 

    let params = this.dutilidades.getQueryStringParams(queryStringParams, false);   
    //Version
    this.enProceso = true;
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
    let anioVersion = Number(objetoFormulario.anio);
    let periodoVersion = Number(periodo);
    let observableVersionFormato = this.dServicioRESTAPI.obtenerVersionDocumento(anioVersion, objetoFormulario.periodicidad, periodoVersion, indModoFraccion);
    observableVersionFormato.subscribe(
        res => {
            let version = <DVersionRutaFormato>res;       
            precargaProceso.close();
            this.enProceso = false;  
            this.logger.info("URL Copiar formulario: ", location.origin + version.urlFormato + 'v' + version.version + '?' + params);              
            this. redirigirFormulario(version,params);  
        },
        error => {
            precargaProceso.close();
            this.enProceso = false;
            this.dNotificacionServicio.mostrarDialogoPersonalizado("Advertencia","El formulario solicitado no esta disponible para su diligenciamiento.",null,null,null,null);
        }
    );      
}   

public dirigirPagoPrimeraCuota() {
    this.enProcesoPago = true;
    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();

        //Valida si ya existe borrador, para enviarle al REST el numero de documento del último borrador                
        let borrador = this.arrDocumentosDiligenciamiento.infoFormularios.find(doc=> doc.anio == this.anioSeleccionado);        
        let ideDocumento = (borrador && borrador.identificador) ?  String(borrador.identificador.id) : null;
        let observableServicio = this.dServicioRESTAPI.iniciarPrimerPago(this.anioSeleccionado, ideDocumento);
        observableServicio.subscribe(
            res => {
                if (this.configuracionFormulario.USA_FORMULARIO_PAGO_NUEVO) {

                    let liquidacion = <DLiquidacionRecibo>res;
                    if (liquidacion) {
                        // Se  comenta el código para mostrar el modal de recibo de pago  y se agrega nuevo servicio para enviar la data al componenente pago por cuotas
                        // this.dReciboPagoServicio.mostrarDialogoReciboPago(this.datosContexto, this.firmaRequerida, liquidacion, null, null, true);

                        // Se agrega codigo para la nueva version 2023 en donde se llama al componente directamente en vez de un MatDialog
                        
                        this.generalServcice.enviarDatosReciboPago({contexto: this.datosContexto, tieneFirmaElectronica: this.firmaRequerida, liquidacion: liquidacion, fecha: null, mensajeAntesGuardar: null, pagoPSE: true})
                    }

                }


                precarga.close();
                this.enProcesoPago = false;
            },
            error => {
                precarga.close();
                this.dNotificacionServicio.mostrarDialogoError("Error Generando el recibo de pago.");
                this.enProcesoPago = false;
            }
        );                    
}

public validarPuedePresentarFraccion(){
    let anioFraccion = Number(this.anioSeleccionadoFraccion) - 1;
    let documento = this.arrDocumentosPresentados.infoFormularios.find(doc => doc.anio == anioFraccion);
    if(documento){ //Si existe el documento presentado del año anterior
       // let dialogFirma = this.dNotificacionServicio.mostrarDialogoConfirmacion("Señor Contribuyente: RECUERDE que la Declaración de Fracción año gravable siguiente, es la última Declaración que se presenta ante la DIAN; por la terminación del trámite de liquidación de su empresa o porque término el trámite de liquidación de la sucesión del contribuyente");
      // let dialogFirma = this.dNotificacionServicio.mostrarDialogoConfirmacion("Para presentar la declaración de la fracción de año gravable siguiente a 2023, primero asegúrese de haber presentado la declaración del año gravable 2022. Solo debe presentar esta declaración ante la DIAN, cuando haya concluido la liquidación de la sucesión del contribuyente.");
       let message = 'Para presentar la declaración de la fracción de año gravable siguiente a 4, primero asegúrese de haber presentado la declaración del año gravable 2023. Solo debe presentar esta declaración ante la DIAN, cuando haya concluido la liquidación de la sucesión del contribuyente.';
       const configBody = {
        title: '',
        message: message,
        main_button: "Entendido",
        secondary_button: "",
        info_message: '', 
        main_action: "accept",
        text_align: "text-center",
        button_align: 'text-center',
        width: '350',
        secondaryButtonClass: '',
        mainButtonClass: 'form-control',
        onMainAction: ()=>{this.crearNuevoBorrador('fraccion');}
       }
       this.crearNuevoBorrador('fraccion');
       // this.modalService.show(ModalType.SUCESS, configBody) //Aquí se mostraba el mensaje que se mandó a quitar
     /*   dialogFirma.afterClosed().subscribe(result => {
            if(result) this.crearNuevoBorrador('fraccion');                
        }); */
          
    }else{
        let anioInscripcion = Number(String(this.fechaInscripcionRUT).substr(0,4));
        if(anioInscripcion >= Number(this.anioSeleccionadoFraccion)){ //si el año de inscripción en el rut es 2021 permite
            //let dialogFirma = this.dNotificacionServicio.mostrarDialogoConfirmacion("Señor Contribuyente: RECUERDE que la Declaración de Fracción año gravable siguiente, es la última Declaración que se presenta ante la DIAN; por la terminación del trámite de liquidación de su empresa o porque término el trámite de liquidación de la sucesión del contribuyente");
          /*   let dialogFirma = this.dNotificacionServicio.mostrarDialogoConfirmacion("Para presentar la declaración de la fracción de año gravable siguiente a 2023, primero asegúrese de haber presentado la declaración del año gravable 2022. Solo debe presentar esta declaración ante la DIAN, cuando haya concluido la liquidación de la sucesión del contribuyente.");
            dialogFirma.afterClosed().subscribe(result => {
                if(result) this.crearNuevoBorrador('fraccion');                
            }); */
            let message = 'Para presentar la declaración de la fracción de año gravable siguiente a 2024, primero asegúrese de haber presentado la declaración del año gravable 2023. Solo debe presentar esta declaración ante la DIAN, cuando haya concluido la liquidación de la sucesión del contribuyente.';
            const configBody = {
                title: '',
                message: message,
                main_button: "Entendido",
                secondary_button: "",
                info_message: '', 
                main_action: "accept",
                text_align: "text-center",
                button_align: 'text-center',
                width: '350',
                secondaryButtonClass: '',
                mainButtonClass: 'form-control',
                onMainAction: ()=>{this.crearNuevoBorrador('fraccion');}
               }
             this.modalService.show(ModalType.SUCESS, configBody)
        }else{
            if( !this.permiteFraccion){
               // let dialogFirma = this.dNotificacionServicio.mostrarDialogoConfirmacion("Señor Contribuyente: RECUERDE que la Declaración de Fracción año gravable siguiente, es la última Declaración que se presenta ante la DIAN; por la terminación del trámite de liquidación de su empresa o porque término el trámite de liquidación de la sucesión del contribuyente");
              /*  let dialogFirma = this.dNotificacionServicio.mostrarDialogoConfirmacion("Para presentar la declaración de la fracción de año gravable siguiente a 2023, primero asegúrese de haber presentado la declaración del año gravable 2022. Solo debe presentar esta declaración ante la DIAN, cuando haya concluido la liquidación de la sucesión del contribuyente.");
               dialogFirma.afterClosed().subscribe(result => {
                if(result) this.crearNuevoBorrador('fraccion');                
            }); */
            /*let message = 'Para presentar la declaración de la fracción de año gravable siguiente a 2024, primero asegúrese de haber presentado la declaración del año gravable 2023. Solo debe presentar esta declaración ante la DIAN, cuando haya concluido la liquidación de la sucesión del contribuyente.';
            const configBody = {
              title: '',
              message: message,
              main_button: "Entendido",
              secondary_button: "",
              info_message: '', 
              main_action: "accept",
              text_align: "text-center",
              button_align: 'text-center',
              width: '350',
              secondaryButtonClass: '',
              mainButtonClass: 'form-control',
              onMainAction: ()=>{this.crearNuevoBorrador('fraccion');}
             }
             this.modalService.show(ModalType.SUCESS, configBody)*/
             this.dNotificacionServicio.mostrarDialogoError(`Para presentar la declaración de fracción del año gravable en curso, es requisito haber presentado la declaración correspondiente al año gravable inmediatamente anterior.`);
            }/*else{
                this.dNotificacionServicio.mostrarDialogoError(`Para presentar la declaración de fracción del año gravable en curso, es requisito haber presentado la declaración correspondiente al año gravable inmediatamente anterior.`);
            }*/
        }       
    }     
}

public confirmarAnulacion(objetoFormulario: DInfoResumenFormulario){
    let confirmacion = this.dNotificacionServicio.mostrarDialogoConfirmacion("Señor Contribuyente: Al oprimir “Confirmar” se procede con la anulación del borrador de esta declaración y debe realizar un nuevo diligenciamiento");

    confirmacion.afterClosed().subscribe(
        res=>{
            if(res){
                this.anularFormulario(objetoFormulario);
            }                
        }
    );
}

public anularFormulario(objetoFormulario: DInfoResumenFormulario) {
    let ideDocumento = String(objetoFormulario.identificador.id);
    let observableVersionFormato = this.dServicioRESTAPI.anularFormulario(ideDocumento);
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
    observableVersionFormato.subscribe(
        res => { 
            precargaProceso.close();
            this.enProceso = false;  
            this.dNotificacionServicio.mostrarDialogoInformacion("Se ha anulado el documento: "+objetoFormulario.identificador.id);
            this.arrDocumentosDiligenciamiento =  new DListaDocumentos();
            this.obtenerDocs();   
        },
        error => {
            precargaProceso.close();
            this.enProceso = false;
            this.dNotificacionServicio.mostrarDialogoError("No fue posible eliminar el documento: "+objetoFormulario.identificador.id);
        }
    );           
} 

public validarPuedePagarCuota(anioSeleccionado){
    let docPresentadoAnio = this.arrDocumentosPresentados.infoFormularios.find( doc => doc.anio == anioSeleccionado);
    if(docPresentadoAnio){
        this.existenDocsPresentadosAnio = true;
    }
}

public validarActivarBotonPagoCuotas(){
    let periodicidad = this.periodicidadFormato.listaPeriodicidades.find(period=> period.nombre == this.periodicidadSelecionada);
    let idePeriodicidad;
    if(periodicidad.id == 1){//pendiente consultar este dominio y cruzar contra valores
        idePeriodicidad = 19110708;
    }else if(periodicidad.id == 4){
        idePeriodicidad = 19110706;
    }else if(periodicidad.id == 3){
        idePeriodicidad = 19110712;
    }else if(periodicidad.id == 6){
        idePeriodicidad = 19110705;
    }else if(periodicidad.id == 12){
        idePeriodicidad = 19110704;
    }
    let version = this.versionesRuta.find(ver=> ver.anioGravable == this.anioSeleccionado && ver.idPeriodicidad == idePeriodicidad && this.periodoSeleccionado.id <= ver.idPeriodo && ver.indModoFraccion == "N");        
    if(version && version.indPagoCuota == "S"){
        this.disableBtnPagoCuotas = false;
    }else{
        this.disableBtnPagoCuotas = true;
    }       
}

/**
* @desc Funcion para obtener todas las versiones del formulario que esten en Angular
* @param {Number} ideFormato
*/
public obtenerVersionesRuta(ideFormato:number){
    let observableVersionesFormato = this.dServicioRESTAPI.obtenerVersionesRuta(ideFormato);
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga(); 
    observableVersionesFormato.subscribe(
        res => { 
            this.versionesRuta = <Array<DVersionRutaFormato>>res;

            // Descomentar en caso de ser necesario enviar las versiones ruta a otros componentes -------------------------------------------------------------------
            // this.generalServcice.enviarVersionesRuta(<Array<DVersionRutaFormato>>res);
            let anio = 0;
            for(let version of this.versionesRuta){
                if(version.indModoFraccion == "S" && version.indAccesoFormulario == "S"){//Se buscan si hay versiones fracción de año
                    this.habilitarFraccionAnio = true;//Si hay fracción se activa el toolbar de fracción                        
                    if (anio < version.anioGravable) anio = version.anioGravable; 
                    this.verificarFraccionAnio(anio);//Verificar que la fracción sea mayor al año actual
                }
            }
            this.aniosFraccion.push(anio);//Se agrega el ultimo año que sea fracción o 0
            this.mostrarNuevoBorradorFraccion = this.habilitarFraccionAnio ? true : false;
            precargaProceso.close();
            this.enProceso = false;  
        },
        error => {
            precargaProceso.close();
            this.enProceso = false;
            this.dNotificacionServicio.mostrarDialogoError("No fue posible obtener las rutas de la versión del formulario. Refresque la página.");
        }
    );    
}

public redirigirFormulario(version:DVersionRutaFormato, params:string){
    if(version.indAccesoFormulario == "N"){
        this.dNotificacionServicio.mostrarDialogoError("El formulario solicitado no esta disponible para su diligenciamiento.");
    }else{
        window.location.href = location.origin + version.urlFormato + 'v' + version.version + '?' + params;
    } 
}   

public validarAnularDefinitivos(anio, concepto, modoNoExperto = false){
    let documentosPorAnular:Array<any> = [];
    if(this.firmaRequerida && this.arrDocumentosDefinitivos.infoFormularios.length > 0){
        for(let i = 0; i < this.arrDocumentosDefinitivos.infoFormularios.length; i++){
            if(this.arrDocumentosDefinitivos.infoFormularios[i].anio == anio){
                documentosPorAnular.push(this.arrDocumentosDefinitivos.infoFormularios[i].identificador.id);
            }
        }
    }

    if(documentosPorAnular.length>0){

        let dialogConfirmar = this.dNotificacionServicio.mostrarDialogoConfirmacion("SEÑOR CONTRIBUYENTE SE HA DETECTADO QUE TIENE INSTRUMENTO DE FIRMA ELECTRÓNICA (IFE) Y HA DILIGENCIADO LOS SIGUIENTES FORMULARIOS ANTES DE SOLICITAR LA FIRMA:<br><br>"+documentosPorAnular.join()+"<br><br>Si no ha presentado uno de estos documentos en el banco, debe proceder a anularlos para que presente su declaración virtualmente haciendo uso de la firma IFE.");
        dialogConfirmar.afterClosed().subscribe(result => {
            if(result){
                this.anularDefinitivos(documentosPorAnular, concepto);
            }else{
                return false;
            }                
        }); 
    }else{
        this.crearNuevoBorrador(concepto, modoNoExperto);
    }
} 

public anularDefinitivos(documentosPorAnular, concepto){

    let requestArray = [];

    for(let documento of documentosPorAnular){
        let resquest = this.dServicioRESTAPI.anularFormulario(documento);
        requestArray.push(resquest);
    }

    forkJoin(requestArray).subscribe(
        results => {
            let dialog = this.dNotificacionServicio.mostrarDialogoInformacion("Documentos definitivos anulados");
            dialog.afterClosed().subscribe(
                result=>{
                    this.crearNuevoBorrador(concepto);
                }
            );
        },error=>{
            this.dNotificacionServicio.mostrarDialogoError("No se han podido anular los documentos definitivos.");
    });        
}

private validarAccesoFormato(ideFormato:number, numVersionFormato:number, numIdentificacion:number, modoUso:number){
let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();  
this.dDiligenciamientoServicios.validarAccesoFormato(ideFormato,numVersionFormato,numIdentificacion,modoUso).subscribe(
  res=>{
    precargaProceso.close(); 
    let fecha = new Date();
    let acceso = <DAccesoFormato>res;
    let inicioVigencia = new Date( Number(acceso.valIniVigencia.toString().substring(0,4)) , Number(acceso.valIniVigencia.toString().substring(4,6)) -1 ,  Number(acceso.valIniVigencia.toString().substring(6,8)));
    let finVigencia = new Date( Number(acceso.valFinVigencia.toString().substring(0,4)), Number(acceso.valFinVigencia.toString().substring(4,6)) -1,  Number(acceso.valFinVigencia.toString().substring(6,8) ) );
    if(fecha >= inicioVigencia && fecha <= finVigencia){
      this.permiteFraccion = true;
    }
  },error=>{
    precargaProceso.close();
  }
);
}

public obtenerFechaInscripcionRUT(){
let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
this.dServicioRESTAPI.obtenerFechaInscripcionRUT().subscribe(
res=>{
    precargaProceso.close();
    let respuesta = <DFechaInscripcionRUT>res;
    this.fechaInscripcionRUT = respuesta.fechaInscripcionRUT;
},error=>{
    precargaProceso.close();
    this.dNotificacionServicio.mostrarDialogoError("No es posible validar la fecha de inscripción en el RUT. Intente de nuevo.", error);
});
}

public consultarFormulario(ideFormato:string){
    let idEndPoint = 'Renta210Ingreso';
    let pathConfiguracion ='./assets/@dian-api/renta210-ingreso/configuracion'
   this.dformulario = new DFormularioServicio(this.dContextoUsuarioServicio.getContextoServicio());
   let documento = this.dformulario.consultarFormulario(ideFormato,idEndPoint,pathConfiguracion); 
   return documento;
}
public  deepClone(object:any){
    var clone ={};
    for(var key in object)
    {
        var value = object[key];
        if(typeof(value) != 'object')
        {
            clone[key] = value;
        }
        else{
            clone[key] = this.deepClone(value);
        }
    }
    return clone;
}

 

/**
 * @desc Función para redireccionar a un link especifico de Muisca
 */
public hrefButton(href: string) {
    window.location.href = location.origin + href;
  }

/////////////////servicio 210 v18
/*
obtenerSugeridaNube()
  {
   
 
    const preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dContextoUsuario.consultarContextoUsuarioMuisca().subscribe(
      (res: DContextoMuisca) => {
        const contexto = <DContextoMuisca>JSON.parse(sessionStorage.getItem('DIAN-MUISCATK'));
        if (!contexto) {
          this.dNotificacionServicio.mostrarDialogoError("Error obteniendo el contexto para la declaraciÃ³n sugerida desde nube");
          return;
        }
        this._restSugeridaNube.initialize(contexto.token.idToken, contexto.token.clientId);
        this._restSugeridaNube.obtenerSugeridaNube("CC",""+this.personaRUTJSON.nit).subscribe(
          res => {
            preloader.close();
            if (!res) return;
            this._messagesObs.sendMessages('show-declasug', true);
            this.showFirstModalHelpDeclaracionSugerida();
            this.asignaCasillaSugerida(res);
  
            
          },
          error => {

          preloader.close();
           
          }
        ); 
      }
    );  
    
  }
*/
asignaCasillaSugerida(objSugerida:any)
{
  /*objSugerida={
    "data": {
        "id": "9999999999",
        "numDocumento": "98772488",
        "nit": 98772488,
        "ideTipoDocumento": 10910094,
        "tipoDocumento": "C. C.",
        "anoGravable": 2023,
        "nomRazonSocial": null,
        "version": null,
        "formato": null,
        "tope1": 100000000,
        "tope2": 20000000,
        "tope3": 3000000,
        "tope4": 40000000,
        "tope5": 5000000,
        "tope6": null,
        "c297": 20000000,
        "c29": 110000000,
        "c30": 25000000,
        "c32": 140000000,
        "c355": 140000000,
        "c33": 45000000,
        "c35": 5000000,
        "c36": 0,
        "c43": 0,
        "r44": 11111111,
        "c58": 0,
        "c59": 0,
        "c63": 0,
        "c74": 0,
        "c76": 0,
        "c80": 0,
        "c98": 0,
        "c99": 0,
        "c100": 0,
        "c104": 0,
        "c105": 0,
        "c107": 0,
        "c302": 0,
        "c112": 15000000,
        "c113": 5000000,
        "c114": 0,
        "c122": 0,
        "c123": 0,
        "c124": 0,
        "c130": 0,
        "c131": 0,
        "c132": 0,
        "ident": 0,
        "ident1": 0,
        "ident2": 0,
        "ident3": 0,
        "ident4": 0,
        "ident5": 0,
        "ident6": 0,
        "plazo": null,
        "fechaCorte": null
    },
    "respuesta": {
        "codigo": 200,
        "mensaje": "Operación exitosa. ",
        "timestamp": "2024-07-10T16:45:53.045+00:00"
    }
  } */
  let keys = Object.keys(objSugerida.data);
  
  this.declaracionSugerida=new DDeclaracionSugerida(); 
  for (let i in keys) 
  {
    const caracter = keys[i].substring(0,1); 
    const casilla = keys[i]; 
    if (caracter.toString()=== CARACTERSUGERIDA) 
    {
      const casilanumerica=casilla.replace(CARACTERSUGERIDA,'');
      const casillaformulario='cs_id_'+casilanumerica.trim();
      const casillasugerida='valSugeridoCasilla'+casilanumerica;
      this.declaracionSugerida[casillasugerida]=objSugerida.data[keys[i]] != null 
                    ?this.dutilidadesMat.obtenerFormatoMoneda(""+objSugerida.data[keys[i]]):'0';
      //this.modelo.doc.cuerpo[casillaformulario]=objSugerida.data[keys[i]];
    }
  }
  this.declaracionSugerida.ideFormato=FORMATO;
  this.declaracionSugerida.anioGravable=this.sugerida;
  this.declaracionSugerida.numIdentificacion =Number(objSugerida.data.numDocumento);
  this.declaracionSugerida.numVersionFormato =18;
  
  
  
 //this.declaracionSugerida;
}
consultarSaldoDevoluciones(){
    let boolDevoluciones=false;
    this.dContextoUsuarioServicio.consultarContextoUsuarioMuisca().subscribe(
    (res: DContextoMuisca) => {
    const contexto = <DContextoMuisca>JSON.parse(sessionStorage.getItem('DIAN-MUISCATK'));
    if (!contexto) {
      return;
    }
  this.datosDevoluciones.initialize(contexto.token.idToken, contexto.token.clientId);
  const nitenviado=this.datosContexto.ANombrePropio ? ""+this.datosContexto.NitUsuario : ""+this.datosContexto.NitOrganizacion;
  let observableServicio = this.datosDevoluciones.consultarSaldoDevolucion(nitenviado);
        observableServicio.subscribe(
            res => {
                boolDevoluciones=res.escandidato;
                this.generalServcice.setDevolucioneshref(res.url);
                this.generalServcice.setrequestEnvio( <string>this.datosDevoluciones.getidreQuest());
                this.generalServcice.setDevoluciones(boolDevoluciones);
               
                
            },
            error => {
            boolDevoluciones=false;
            this.generalServcice.setDevolucioneshref('');
            this.generalServcice.setrequestEnvio('');
            this.generalServcice.setDevoluciones(boolDevoluciones);
           // this.generalServcice.setrequestEnvio( <string>this.datosDevoluciones.getidreQuest());
            
            }
        );
   
    }
    
    );
    
} 

}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/components/contenedor/contenedor.component.ts